import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: 200,
    fontSize: 18,
    background: 'transparent',
    color: '#fff',
    fontFamily: 'PoppinsSemibold',
    [theme.breakpoints.down('820')]: {
      width: 170,
    },
    [theme.breakpoints.down('720')]: {
      width: 140,
    },
    [theme.breakpoints.down('600')]: {
      width: '90%',
      borderRadius: 24,
      padding: '5px 8px',
      color: '#fff',
    },
    padding: 5,
    '&::after, &::before': {
      borderBottom: `2px solid #fff`,
    },
    '& svg': {
      color: '#fff',
    },
    '& > div': {
      fontFamily: 'PoppinsSemibold',
      '&:focus': {
        background: 'transparent',
      },
      '& > div': {
        '&:focus': {
          background: 'transparent',
        },
      },
    },
  },
});

function ListOption(props) {
  const {
    classes,
    data,
    value: selectedValue,
    changeHandler,
    type,
    placeholder,
  } = props;
  if (_isEmpty(data)) return null;
  return (
    <Select
      value={selectedValue || 'none'}
      name={`${type}-topic-filter`}
      id={`topic-filter-${type}-${selectedValue}`}
      labelId={`topic-filter-${type}-${selectedValue}`}
      onChange={event => changeHandler(event, type)}
      className={classes.root}
    >
      {_isEmpty(selectedValue) && (
        <MenuItem value="none" disabled>
          {placeholder}
        </MenuItem>
      )}
      {data.map(({ label, value }) => (
        <MenuItem value={value} key={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
}

ListOption.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  value: PropTypes.string,
  changeHandler: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
};
export default withStyles(styles)(ListOption);
